<template>
  <div class="fav-record-main">
    <div class="main-box">
      <div class="result-count">
        <span>共<b>{{rowCount}}</b>人</span>
        <div class="sort">
          <span :class="sort.field === 'CNT' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('CNT')"
            >唱片数</span
          >
          <span :class="sort.field === 'NAME' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('NAME')"
            >名称</span
          >
           
        </div>
      </div>
      <div class="filter-keys" v-if="filterKeys.length>0">
        <div class="lb">已选项：</div><div v-for="(f,index) in filterKeys" :key="index+f.text" class="f-k"><b v-if="f.name">{{f.name}}:</b>{{f.text}} <i class="cls" @click="deleteFilter(f,index)"></i></div>
      </div>
      <div class="company-list">
        <div v-for="(item,index) in recordList" :key="'recordList'+index" class="company-cell">
          <div class="index">{{index+1}}</div>
          <div class="pic">
            <router-link :to="'/musician-detail/'+encodeURIComponent(item['@id'])">
              <img v-if="item.img" :src="item.img || 'img/demo/image.png'" alt="">
              <div v-else :class="'base-pic-placeholder bg'+parseInt(Math.random()*6)">
                {{(item.name['@value']).substring(0,1)}}
              </div>
            </router-link>
          </div>
          <div class="info">
             <router-link :to="'/musician-detail/'+encodeURIComponent(item['@id'])">
            <div class="name" v-if="item.name"> 
                  {{item.name['@value']}}
              </div>
            <div class="des" v-if="item.briefBiography">
              {{item.briefBiography.replace(/,/g,'，').replace(/[.]/g,'。').split('（来源')[0]}}
            </div>
            </router-link>
          </div>
          <div class="count" v-if="item.phonoAmt">
            <b>{{item.phonoAmt}}</b>唱片
          </div>
          
          <div class="act">
            <span class="play"></span>
            <span :class="item.isFavorite ? 'fav cur' : 'fav'" @click="handleFav(index)"></span>
            <span class="share"></span>
          </div>
        </div>
      </div>
      <div class="page-box">
        <a-pagination 
          :total="pagerCount" 
          :current="currentPage" 
          @change="onChange" 
          show-quick-jumper show-less-items />
      </div>
      <Player ref="player"/>
    </div>
  </div>
</template>

<script>
import { eventBus } from './../../util/eventBus';
import { personSearchPost ,collFav,ncollFav } from "@/api";
import Player from "@/components/player";
export default {
  components: {
    Player
  },
  data(){
    return {
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      searchParams: {}, // 检索参数
      paramsObj: {
        firstChar: '',
        pageSize: 10,
        pageth: 1
      },
      themeDict:[
        {
          name:'流行歌曲',
          count:122
        },
        {
          name:'进步歌曲与红歌',
          count:122
        },
        {
          name:'沪剧与滑稽戏',
          count:122
        },
        {
          name:'语言教学片',
          count:122
        },
        {
          name:'民族乐器',
          count:122
        }
      ],
      themeCurrent:-1,
      recordCurrent:-1,
      langCurrent:-1,
      recordDict:[
        {
          name:'密纹',
          count:12
        },
        {
          name:'粗纹',
          count:12
        },
        {
          name:'名称',
          count:12
        }
      ],
      langDict:[
        {
          name:'中文',
          count:12
        },
        {
          name:'外文',
          count:12
        }
      ],
      rowCount: 0,
      pagerCount: 1,
      currentPage: 1,
      recordList:[],
      showAll:[true,true,false,false,false,false],
      filterKeys:[],
      cdtn:[],
      sort: {
        field: "CNT",
        order: "asc"
      }
    }
  },
  beforeRouteUpdate(a){
    this.filterKeys = [];
    if(a.query.keyword){
      this.filterKeys.splice(0,1,{
        text:a.query.keyword,
        dict:'keyword'
      })
    }
    this.currentPage = 1;
    this.searchParams = this.commonParamsHandling(1, a.query.keyword);
  },
  watch: {
    $route: {
      handler: function(val, oldVal){
        //如果搜索的参数有修改，则需要更改或删除当前列表检索条件
        this.initFilterKeys();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if(this.$route.query.keyword){
        this.filterKeys.push({
          text:this.$route.query.keyword,
          dict:'keyword'
        })
      }
      this.initBus();
    });
  },
  methods:{
    initBus(){
      eventBus.$on("setAdvance", (data) => {
        data.forEach(item=>{
          this.filterKeys.push({
            text:item.val,
            dict:item.name
          })
        })
      });
    },
    initData () { // 初始化
      this.recordList = [];
      this.rowCount = 0;
    },
    initFilterKeys() {
      //如果搜索的参数有修改，则需要更改或删除当前列表检索条件
      if(this.$route.query.keyword){
        for(let i =0;i<this.filterKeys.length;i++){
          if(this.filterKeys[i].dict == 'keyword'){
            this.filterKeys.splice(i,1)
          }
        }
        this.filterKeys.push({
          text: this.$route.query.keyword,
          dict: "keyword",
        });
      }else if(!this.$route.query.keyword){
        for(let i =0;i<this.filterKeys.length;i++){
          if(this.filterKeys[i].dict == 'keyword'){
            this.filterKeys.splice(i,1)
          }
        }
      }
    },
    onParamsHandle() { // 检索参数设置
      // 初始化
      this.initData();
      this.searchParams = this.commonParamsHandling();
      // 排序
      const { field, order } = this.sort;
      this.searchParams.sorts = {
        [field]: order === "asc" ? 1 : 0
      };
      // 页码
      this.searchParams.pager.pageth = this.currentPage;
      // 高级搜索，如果高级搜索有内容，则需要添加到已选项中，高级搜索清空之后，则需要清空已选项中的高级搜索内容
      if (this.cdtn.length != 0) {
         for (let j = 0; j < this.filterKeys.length; j++) {
          if (this.filterKeys[j].name) {
            this.filterKeys.splice(j, 1);
            j--
          }
        }
        this.searchParams.cdtn = this.cdtn;
        this.searchParams.searchType = 2;
        for (let i = 0; i < this.cdtn.length; i++) {
          for (let j = 0; j < this.filterKeys.length; j++) {
            if (this.filterKeys[j].name == this.cdtn[i].name) {
              this.filterKeys.splice(j, 1);
            }
          }
          this.filterKeys.push({
            text: this.cdtn[i].value,
            name: this.cdtn[i].name,
            dict: this.cdtn[i].name,
          });
        }
      } else {
        for (let j = 0; j < this.filterKeys.length; j++) {
          if (this.filterKeys[j].name) {
            this.filterKeys.splice(j, 1);
            j--;
          }
        }
      }
      if(this.filterKeys.length < 1) return;
      let sim = false;
      this.filterKeys.forEach((item,index)=>{
        const dict = item.dict;
        // 简单检索
        if(dict == 'keyword') {
          this.searchParams.searchType = 1;
          this.searchParams.freetext = item.text;
        }
        // 分面参数
        if(dict.indexOf('Dict') != -1){
          this.searchParams.facet[dict.replace('Dict','').toUpperCase()] = item.text;
        }
      })
      
    },
    async handleFav(index){
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$parent.showTk(2);
        return;
      }
      const res = this.recordList[index].isFavorite
        ? await ncollFav({ uri: this.recordList[index]["@id"] })
        : await collFav({ uri: this.recordList[index]["@id"] });
      this.recordList.splice(index, 1, {
        ...this.recordList[index],
        isFavorite: !this.recordList[index].isFavorite,
      });
      
      this.$parent.coll(this.recordList[index].isFavorite);
    },
    async query() { // 查询
      // 参数设置
      this.recordList = []
      this.onParamsHandle();
      const res = await personSearchPost(this.searchParams);
      const result = res.data;
      this.recordList = result.datas;
      // 总数
      this.rowCount = result.pager.rowCount;
      // 页码
      this.pagerCount = result.pager && result.pager.rowCount ? result.pager.rowCount : 1;
      //console.log(result);
    },
    onCountHnadle(key) { // 统计数量
      this[key+'Count'] = 0;
      this[key+'Dict'].forEach((item, index)=>{
        this[key+'Count'] += item.count;
      })
    },
    showAllHandle(a){
      this.showAll.splice(a,1,!this.showAll[a])
      let count = 0
      this.showAll.forEach(item=>{
        if(item){
          count ++
        }
      })
      if(count>3){
        let flag = false
        this.showAll.forEach((item,index)=>{
          if(item&&index!==a&&!flag){
            flag = true
            this.showAll.splice(index,1,false)
          }
        })
      }
    },
    deleteFilter(item,index){
      //item中包含name字段，则代表是高级搜索，无，则是正常的左侧栏搜索
      // 删除包含name字段时，则需要修改高级搜索的查询条件
      if (item.name) {
        for (let i = 0; i < this.cdtn.length; i++) {
          if (this.cdtn[i].name == item.name) {
            this.cdtn.splice(i, 1);
          }
        }
      } else {
        this[
          this.filterKeys[index].dict.substring(
            0,
            this.filterKeys[index].dict.search("Dict")
          ) + "Current"
        ] = -1;
      }
      this.filterKeys.splice(index,1);
      this.currentPage = 1;
      this.query();
    },
    handleFilter(index,key){
      this[key+'Current'] = index
      const _i = this.filterKeys.findIndex(item=>{
        return item.dict === key+'Dict'
      })
      if(_i!==-1){
        if(index===-1){
          this.filterKeys.splice(_i,1)
        }else{
          this.filterKeys.splice(_i,1,{
            dict: key+'Dict',
            text: this[key+'Dict'][index].name
          })
        }
      }else{
        this.filterKeys.push({
          dict: key+'Dict',
          text: this[key+'Dict'][index].name
        })
      }
      this.currentPage = 1;
      this.query(false);
    },
    handleSortChange(field) {
      if (field === this.sort.field) {
        this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
      } else {
        this.sort.field = field;
        this.sort.order = "asc";
      }
      this.query(false);
    },
    onChange (current) { // 页码点击
      this.currentPage = current;
      this.query(false);
    },
  }
}
</script>
